(function () {
  'use strict';

  var translations = {
    '100 points': '100 punkti',
    '1000 points': '1000 punkti',
    '125 points': '125 punkti',
    '1× points per 1€ spent': '1× punktimäär iga kulutatud 1€ eest',
    '2 points for every €1 spent': '2 punkti iga kulutatud 1€ eest',
    '20 points': '20 punkti',
    '200 points': '200 punkti',
    '2000 points': '2000 punkti',
    '5 points for every €1 spent': '5 punkti iga kulutatud 1€ eest',
    '500 points': '500 punkti',
    'Activity': 'Tegevus',
    'Advancing through our VIP tiers is simple: earn points through purchases and program activities. Each tier has specific point requirements, and your progress is clearly displayed in your rewards dashboard. The more you engage with our program, the faster you\'ll unlock premium benefits.': 'VIP-tasemel edasi liikumiseks kogu punkte ostude ja boonusklubi tegevustega. Igal tasemel on oma punktipiir ning oma edenemist näed boonusklubi vaates.',
    'Assigned to the {tier_name} tier': 'Liitusid tasemega {tier_name}',
    'Become a member': 'Liitu boonusklubiga',
    'Bronze': 'Pronks',
    'Celebrate a birthday': 'Lisa oma sünnipäev',
    'Claim reward': 'Võta preemia',
    'Create an account on our store': 'Loo Peachys Weari konto',
    'Custom discount of {currency_symbol}{amount} for {points} points': 'Vaheta {points} punkti {currency_symbol}{amount} soodustuseks',
    'Daily visit': 'Igapäevane külastus',
    'Date': 'Kuupäev',
    'Discount code is already used': 'Sooduskood on juba kasutatud',
    'Do my reward points expire?': 'Kas boonuspunktid aeguvad?',
    'Earn': 'Kogu punkte',
    'Earn Points': 'Kogu punkte',
    'Earn points by completing these actions': 'Kogu punkte nende tegevustega',
    'Earn points for every purchase and redeem rewards.': 'Kogu iga ostuga punkte ja vaheta need preemiateks.',
    'Earn points for shopping': 'Kogu ostudega punkte',
    'Earned a {title} for being referred by a friend': 'Said sõbra kutse eest preemia: {title}',
    'Earned a {title} for referring a friend': 'Said sõbra kutsumise eest preemia: {title}',
    'Earned {points} points by celebrating a birthday': 'Teenitud {points} punkti sünnipäeva lisamise eest',
    'Earned {points} points by completing a social action': 'Teenitud {points} punkti sotsiaalmeedia tegevuse eest',
    'Earned {points} points by following on Instagram': 'Teenitud {points} punkti Instagramis jälgimise eest',
    'Earned {points} points by following on TikTok': 'Teenitud {points} punkti TikTokis jälgimise eest',
    'Earned {points} points by following on X': 'Teenitud {points} punkti X-is jälgimise eest',
    'Earned {points} points by liking on Facebook': 'Teenitud {points} punkti Facebookis meeldivaks märkimise eest',
    'Earned {points} points by placing an {order_value} order': 'Teenitud {points} punkti {order_value} väärtuses tellimuse eest',
    'Earned {points} points by placing your first {order_value} order': 'Teenitud {points} punkti esimese {order_value} väärtuses tellimuse eest',
    'Earned {points} points by sharing on Facebook': 'Teenitud {points} punkti Facebookis jagamise eest',
    'Earned {points} points by sharing on X': 'Teenitud {points} punkti X-is jagamise eest',
    'Earned {points} points by signing up': 'Teenitud {points} punkti liitumise eest',
    'Earned {points} points by subscribing to the newsletter': 'Teenitud {points} punkti uudiskirjaga liitumise eest',
    'Earned {points} points by visiting a link': 'Teenitud {points} punkti lingi külastamise eest',
    'Earned {points} points by visiting on {visited_on}': 'Teenitud {points} punkti külastuse eest kuupäeval {visited_on}',
    'Enter your email address': 'Sisesta oma e-post',
    'Enter your email to receive a discount on your first purchase. The code will be sent after registration.': 'Sisesta oma e-post, et saada esimeselt ostult 10% soodustust. Kood saadetakse pärast registreerimist.',
    'Exchanged {points} points for a {title} reward': 'Vahetasid {points} punkti preemia vastu: {title}',
    'Exclusive Early Access to New Collections': 'Varajane ligipääs uutele kollektsioonidele',
    'FRIEND INVITATION': 'KUTSU SÕBER',
    'Follow': 'Jälgi',
    'Follow on Instagram': 'Jälgi meid Instagramis',
    'Follow on TikTok': 'Jälgi meid TikTokis',
    'Free': 'Tasuta',
    'Frequently Asked Questions': 'Korduma kippuvad küsimused',
    'Get 15% Off your first Order': 'Saa esimeselt tellimuselt 10% soodustust',
    'Give 10%, Get 10%': 'Anna 10%, saa 10%',
    'Give them 10% off their first order, and you’ll get 10% once they make a purchase.': 'Sõber saab esimeselt tellimuselt 10% soodustust ja sina saad 10%, kui tema ost on tehtud.',
    'Have questions? We have answers!': 'Siit leiad vastused kõige olulisematele küsimustele.',
    "Here's an overview of your current points balance and recent activity": 'Siin näed oma punktisaldot ja viimaseid tegevusi.',
    'Hey Babe, you have {points} Points': 'Hei, babe! Sul on {points} punkti',
    'Hooray! You set your birthday and will receive a reward on your special day!': 'Valmis! Sinu sünnipäev on lisatud ja saad tähtsal päeval preemia.',
    'Hooray! You subscribed to our newsletter!': 'Valmis! Liitusid uudiskirjaga.',
    'How It Works': 'Kuidas see töötab?',
    'How can I track my rewards and tier status?': 'Kust näen oma punkte ja preemiaid?',
    'How do I advance to higher VIP tiers?': 'Kuidas jõuan järgmisele VIP-tasemele?',
    'How do I become a member?': 'Kuidas boonusklubiga liituda?',
    'IT’S A FRIEND THING': 'SÕPRADE VÄRK',
    'Join Now': 'Liitu kohe',
    'Join for free and begin earning Peachys points! 🧡': 'Liitu tasuta ja hakka Peachysi punkte koguma! 🧡',
    'Join our VIP program and get exclusive rewards': 'Liitu VIP-programmiga ja saa eksklusiivseid preemiaid.',
    'Like': 'Märgi meeldivaks',
    'Like on Facebook': 'Märgi meid Facebookis meeldivaks',
    'Loyalty Club': 'Boonusklubi',
    'Maximum shipping total allowed to redeem this reward is {amount}': 'Selle preemia kasutamisel võib tarne maksumus olla kuni {amount}',
    'Membership is automatic and completely free! Simply create an account or place your first order, and you\'ll instantly become part of our rewards community. No additional sign-up steps required.': 'Liitumine on tasuta. Loo konto või tee esimene tellimus ning oled automaatselt Peachysi boonusklubi liige.',
    'Minimum order total required to redeem this reward is {amount}': 'Selle preemia kasutamiseks peab tellimuse summa olema vähemalt {amount}',
    'Needs to be set at least 30 days before your birthday to receive a reward': 'Preemia saamiseks lisa sünnipäev vähemalt 30 päeva ette.',
    'No': 'Ei',
    'No actions available': 'Ühtegi tegevust pole saadaval',
    'No activity yet': 'Tegevusi veel pole',
    'No rewards available': 'Ühtegi preemiat pole saadaval',
    'No rewards redeemed yet': 'Sa pole veel preemiaid kasutanud',
    'Our Rewards Program is an exclusive loyalty system designed to enhance your shopping experience. Earn points through purchases and special activities, then redeem them for discounts, exclusive products, and VIP benefits. It\'s our way of saying thank you for your continued support.': 'Peachysi boonusklubis kogud punkte ostude ja valitud tegevustega. Punkte saad vahetada soodustuste ja teiste preemiate vastu.',
    'Place an order': 'Tee tellimus',
    'Place your first order': 'Tee esimene tellimus',
    'Points': 'Punktid',
    'Points adjusted for a cancelled order': 'Punkte korrigeeriti tühistatud tellimuse tõttu',
    'Points adjusted for a {order_value} refund': 'Punkte korrigeeriti {order_value} tagastuse tõttu',
    'Points multiplier': 'Punktikordaja',
    'Redeem': 'Kasuta punkte',
    'Redeem Rewards': 'Kasuta preemiaid',
    'Redeem points for these rewards': 'Vaheta punktid nende preemiate vastu',
    'Redeem your points for rewards': 'Vaheta punktid preemiate vastu',
    'Referral discounts are only valid for new customers.': 'Sõbra soodustus kehtib ainult uutele klientidele.',
    'Reward {title} expired': 'Preemia {title} aegus',
    'Rewards': 'Boonusklubi',
    'Share': 'Jaga',
    'Share on Facebook': 'Jaga Facebookis',
    'Sign In': 'Logi sisse',
    'Sign up': 'Liitu',
    'Special Birthday Rewards': 'Erilised sünnipäevapreemiad',
    'Spend {entry_value} to reach the {title} tier!': 'Kuluta veel {entry_value}, et jõuda tasemele {title}.',
    'Subscribe': 'Liitu',
    'Subscribe to our newsletter': 'Liitu uudiskirjaga',
    'Update birthday': 'Salvesta sünnipäev',
    'Use this discount code on your next order!': 'Kasuta seda sooduskoodi järgmisel tellimusel.',
    'VIP Program': 'VIP-programm',
    'VIP-Only Flash Sales & Promotions': 'Ainult VIP-liikmetele mõeldud eripakkumised',
    'Visit': 'Ava',
    'Ways to Earn': 'Kuidas punkte koguda?',
    'Ways to Redeem': 'Kuidas punkte kasutada?',
    'Welcome Back Babe! 🧡': 'Tere tulemast tagasi, babe! 🧡',
    'WELCOME BONUS': 'TERVITUSBOONUS',
    'What is our Rewards Program?': 'Mis on Peachysi boonusklubi?',
    'Yes': 'Jah',
    'You are on your way!': 'Oled järgmisele tasemele teel!',
    'You have the following rewards ready to use': 'Need preemiad on kasutamiseks valmis',
    'Your birthday': 'Sinu sünnipäev',
    'Your discount code is available to use on your next order! 🎉': 'Sinu sooduskood on järgmisel tellimusel kasutamiseks valmis! 🎉',
    'Your email': 'Sinu e-post',
    'Your email address': 'Sinu e-posti aadress',
    'Your name': 'Sinu nimi',
    'Your reward points are yours to keep indefinitely. There\'s no expiration date, giving you complete flexibility to save and redeem your points whenever you choose. We believe in rewarding your loyalty on your terms.': 'Boonuspunktidel ei ole aegumiskuupäeva. Kogu neid rahulikult ja kasuta siis, kui ise soovid.',
    'Your rewards dashboard provides a complete overview of your points balance, tier status, and available benefits. Visit the "Rewards" section to view your points history, redeem rewards, or check your progress towards the next tier level.': 'Boonusklubi vaates näed oma punktisaldot, punktide ajalugu ja saadaolevaid preemiaid.',
    '{amount} added to your store credit — available at checkout! 🎉': '{amount} lisati sinu poekrediidile ja on kassas kasutamiseks valmis! 🎉',
    '{points} points': '{points} punkti',
    '{points} points expired': '{points} punkti aegus',
    '€10 off discount': '10€ soodustus',
    '€20 off discount': '20€ soodustus',
    '€5 off discount': '5€ soodustus'
  };

  function localizeObject(value) {
    if (!value || typeof value !== 'object') return value;

    if (typeof value.en === 'string') {
      value.et = translations[value.en] || value.et || value.en;
    }

    Object.keys(value).forEach(function (key) {
      localizeObject(value[key]);
    });

    return value;
  }

  function translateTextNode(node) {
    var original = node.nodeValue;
    var trimmed = original.trim();
    var translated = translations[trimmed];

    if (!translated) {
      translated = trimmed
        .replace(/^\+(\d+) points for this order$/, '+$1 punkti selle tellimusega')
        .replace(/^(\d+) points to redeem$/, '$1 punkti kasutamiseks');
    }

    if (translated && translated !== trimmed) {
      node.nodeValue = original.replace(trimmed, translated);
    }
  }

  function translateWidget(root) {
    if (!root || root.nodeType !== 1) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) translateTextNode(node);
  }

  function prepareFloatingLauncher() {
    var loyaltyRoot = document.getElementById('honeypop-app');
    if (!loyaltyRoot) return;

    var launcher = Array.from(loyaltyRoot.querySelectorAll('button')).find(function (button) {
      return window.getComputedStyle(button).position === 'fixed';
    });
    if (!launcher) return;

    launcher.classList.add('peachys-loyalty-launcher');
    launcher.setAttribute('aria-label', 'Lojaalsusprogramm');

    var textNodes = [];
    var walker = document.createTreeWalker(launcher, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim()) textNodes.push(node);
    }
    if (textNodes.length) textNodes[textNodes.length - 1].nodeValue = 'Lojaalsusprogramm';
  }

  function prepareCartPlacements() {
    document.querySelectorAll('.honeypop-cp').forEach(function (placement) {
      placement.dataset.primaryLocale = 'et';
      placement.dataset.loggedInText = '+{points} punkti selle tellimusega';
      placement.dataset.loggedOutText = 'Logi sisse, et preemiaid kasutada';
      placement.dataset.btnRedeem = 'Kasuta punkte';
      placement.dataset.pointsLabel = 'punkti';
      placement.dataset.btnNopts = 'Punkte pole piisavalt';
      placement.dataset.headline = '{balance} punkti kasutamiseks';
      placement.dataset.loggedOutHeadline = '+{points} punkti selle tellimusega';
      placement.dataset.btnApply = 'Rakenda';
      placement.dataset.btnRemove = 'Eemalda';
      placement.dataset.doesntCombine = 'Ei kombineeru teiste soodustustega';
      placement.dataset.minOrderLabel = 'Minimaalne tellimus {amount}';
      placement.dataset.errInsufficientPoints = 'Punkte pole piisavalt';
      placement.dataset.errNoCombine = JSON.stringify({
        et: 'Tellimusele on juba lisatud soodustus, mida ei saa selle preemiaga kombineerida.',
        en: 'A discount is already applied and cannot be combined.'
      });
      placement.dataset.errAlreadyRedeemed = JSON.stringify({
        et: 'See preemia on juba kasutatud.',
        en: 'This reward has already been redeemed.'
      });

      try {
        var rewards = JSON.parse(placement.dataset.rewards || '[]');
        localizeObject(rewards);
        placement.dataset.rewards = JSON.stringify(rewards);
      } catch (error) {
        /* Keep the app usable if its own data format changes. */
      }

      translateWidget(placement);
    });
  }

  function init() {
    prepareCartPlacements();

    var loyaltyRoot = document.getElementById('honeypop-app');
    if (loyaltyRoot) translateWidget(loyaltyRoot);
    prepareFloatingLauncher();
    var loyaltyPage = document.getElementById('essential-loyalty-landing-page');
    if (loyaltyPage) translateWidget(loyaltyPage);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (addedNode) {
          if (addedNode.nodeType !== 1) return;
          if (addedNode.matches('#honeypop-app, #honeypop-app *, .honeypop-cp, .honeypop-cp *, #essential-loyalty-landing-page, #essential-loyalty-landing-page *')) {
            translateWidget(addedNode);
          }
          addedNode.querySelectorAll?.('#honeypop-app, .honeypop-cp, #essential-loyalty-landing-page').forEach(translateWidget);
        });
      });
      window.requestAnimationFrame(prepareFloatingLauncher);
    });

    observer.observe(document.body, { childList: true, subtree: true });
    [500, 1500, 3500].forEach(function (delay) {
      window.setTimeout(prepareFloatingLauncher, delay);
    });
  }

  window.PeachysLoyaltyEt = {
    init: init,
    localizeObject: localizeObject
  };
})();
